<template>
    <div class="gh-page">
        <div class="gh-page-breadcrumb">
            <gh-breadcrumb>
                <gh-breadcrumb-item to="/catalogue" :is-last="true">Memberships</gh-breadcrumb-item>
            </gh-breadcrumb>
        </div>

        <div class="gh-section gh-page-intro">
            <div class="container">
                <h1 class="gh-section__heading gh-section__heading-large">Join Now (Risk Free)</h1>
                <p class="gh-section__subheading">Our membership model increases your choices and reduces your costs. As a member, you only pay a fixed monthly or annual membership fee to access {{ LaraVue.figure.totalNumberOfCourses }}+ courses in our Catalogue. And with our 30-day Money Back Guarantee, you can join risk free.</p>
            </div>
        </div>

        <div class="v-memberships-wrapper gh-section">
            <div class="container">
                <h2 class="gh-section__heading">Membership Options</h2>

                <!-- <p class="v-save-up">Save up to $119 (25%) with Annual Billing</p> -->

                <!-- <gh-membership-switch @switch="switchTerm"/> -->

                <!-- <div class="v-memberships">
                    <gh-premium-features :term="term"/>
                    <div class="v-or">
                        <p class="v-or__text">or</p>
                    </div>
                    <gh-standard-features :term="term"/>
                </div> -->
                     <div class="gh-memberships">
                    <div class="gh-membership-card is-featured">
                        <div class="gh-membership-card-header">
                            <span class="gh-ribbon">BEST VALUE</span>
                            <span class="gh-membership-type">Annual</span>
                            <span class="gh-membership-pricing"><span class="gh-pricing-digit">$349</span>/yr</span>
                            <span>Pay upfront & save</span>
                        </div>
                        <div class="gh-membership-card-info">
                            <s>$468</s> (save $119)
                        </div>
                        <div class="gh-membership-card-action">
                            <el-button class="gh-button gh-button--cta" @click="setTerm('annual')">CHOOSE ANNUAL</el-button>
                        </div>
                    </div>

                    <div class="v-or">
                        <p class="v-or__text">or</p>
                    </div>

                    <div class="gh-membership-card">
                        <div class="gh-membership-card-header">
                            <span class="gh-membership-type">Monthly</span>
                            <span class="gh-membership-pricing"><span class="gh-pricing-digit">$39</span>/mth</span>
                            <span>12-month term applies</span>
                        </div>
                        <div class="gh-membership-card-info">
                            Easy instalments
                        </div>
                        <div class="gh-membership-card-action">
                            <el-button class="gh-button gh-button--cta" @click="setTerm('monthly')">CHOOSE MONTHLY</el-button>
                        </div>
                    </div>
                </div>

                <div class="gh-inclusions mt-md">
                    <h2 class="gh-section__heading margin-0">Membership inclusions</h2>
                    <div class="gh-inclusions-inner">
                        <el-row class="gh-includes">
                            <el-col v-for="(item, index) in inclusions" :key="index">
                                <el-row :gutter="20" class="gh-item">
                                    <el-col :span="span">
                                        <div class="gh-text">
                                            {{ item }}
                                        </div>
                                    </el-col>
                                    <el-col :span="24 - span">
                                        <img src="/images/app/icon-purple-circle-graphic.svg" alt="">
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>

        <div class="gh-rates">
            <div class="container">
                <el-row>
                    <el-col :span="24" :md="18">
                        <div class="gh-rates-left">
                            <span>Over 1,000 learners have rated their MHA experience 4.9 out of 5 stars</span>
                            <div class="gh-read-more-reviews">
                                <a href="//www.productreview.com.au/listings/mental-health-academy " class="gh-button-redesign gh-button-redesign--primary gh-button-home-redesign" target="_blank">View their reviews</a>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24" :md="6">
                        <div class="gh-rates-right">
                            <img src="/images/app/5-star-graphic.svg" alt="Purple star" width="20" height="20">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="v-registration" ref="form">
            <div class="v-registration-form">
                <h2 class="gh-section__heading">Secure Registration Form</h2>
                <p class="gh-subheading"><span class="gh-highlight">30-Day Guarantee</span><span> If you’re not satisfied, we’ll give your money back (<a href="/terms" target="_blank">terms apply</a>).</span></p>
                <gh-registration-regular :term="term" />
            </div>
            <gh-bonuses/>
        </div>
    </div>
</template>

<script>
    import UX from '@/utils/ux';
    import {mapGetters} from 'vuex';

    export default {
        components: {
            ghRegistrationRegular: () => import(/* webpackChunkName: "registration" */ '@/modules/registration/components/RegistrationRegularV2.vue'),
            ghBonuses: () => import(/* webpackChunkName: "registration" */ '@/modules/registration/components/Bonuses.vue')
        },

        data() {
            return {
                term: 'annual'
            }
        },

        computed: {
            LaraVue() {
                return LaraVue
            },

            ...mapGetters({
                userDetail: 'auth/userDetail',
            }),

             mhaMember () {
              return this.userDetail('profile')
            },

            span () {
                return this.windowWidth <= 600 ? 21 : 22
            },

            figure () {
                return LaraVue.figure
            },

            inclusions () {
                return [
                    `Unrestricted access to ${this.figure.totalNumberOfCourses}+ CPD courses`,
                    `Free access to MHA Masterclasses (save $145 per event)`,
                    `${this.figure.totalHours}+ hours of video and text learning, on-demand`,
                    `Learn from ${this.figure.totalAuthors}+ global mental health experts`,
                    'Accrue CPD hours/points (Certificates included)',
                    'New courses released every month',
                    'Member-exclusive live events',
                    '30-day money-back guarantee'
                ]
            },
        },

        methods: {
            setTerm(term) {
                this.term = term;

                UX.scrollTo(this.$refs.form);
            }
        },

        watch: {
            mhaMember: {
                immediate: true,
                handler: function(value) {
                    if (value) {
                        this.$router.push({ name: 'memberDashboard.dashboard' });
                    }
                }
            }
        }
    }
</script>


<style lang="scss" scoped>
    .margin-0 {
        margin-bottom: 0px !important;
    }
    .v-memberships-wrapper {
        background: white;
    }

    .gh-page-intro {
        padding-bottom: 2rem;
    }

    .v-tagline {
        max-width: 768px;
        margin: 0 auto;
        color: #2e3038;
        font-weight: 600;
        font-size: 1.5rem;
        text-align: center;
        line-height: 1.5;
    }

    .v-tagline__link {
        color: #24c6dc;
    }

    .v-section-intro {
        max-width: 992px;
        margin: 0 auto;
        color: #565A60;
        font-size: 1.2rem;
        font-weight: 600;
    }

    .gh-memberships-wrapper {
        background: #fff;
        text-align: center;
    }

    .gh-memberships {
        margin-top: 2rem;
    }

    .gh-membership-card {
        max-width: 380px;
        width: 100%;
        margin: 0 auto 2rem;
        border: 1px solid #D5D6D7;
        line-height: 1;
    }

    .gh-membership-card-header {
        position: relative;
        padding: 1rem;
        background: #85D8CE;
        color: #fff;
        text-align: left;
        font-size: 1.5rem;
        font-weight: 300;

        .is-featured & {
            background: #085078;
        }
    }

    .gh-membership-type {
        display: block;
        margin-bottom: 1rem;
        font-size: 2rem;
        font-weight: 500;
    }

    .gh-membership-pricing {
        display: block;
        margin-bottom: 1rem;
    }

    .gh-pricing-digit {
        font-size: 4rem;
        font-weight: 500;
    }

    .gh-membership-card-info {
        padding: 1rem;
        color: #24C6DC;
        background: #E5E5E5;
        text-align: center;
        font-size: 1.5rem;
        font-weight: 600;
    }

    .gh-membership-card-action {
        padding: 1rem;
        text-align: center;
    }

    .gh-ribbon {
        position: absolute;
        top: 1rem;
        right: -1rem;
        padding: 1rem 2rem;
        background: #24C6DC;
        color: #fff;
        font-size: 1.2rem;
        font-weight: 700;

        &::after {
            content: '';
            position: absolute;
            top: 48px;
            right: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 1rem 1rem 0 0;
            border-color: #1CA0B7 transparent transparent transparent;
        }
    }

    .v-or {
        display: none;
    }

    .v-registration {
        background: white;
        padding: 4.3rem 0;
    }
    .v-registration-form {
        padding: 0 10px;
        .gh-section__heading {
            text-align: left;
            font-size: 2.4rem;
        }

        .gh-subheading {
            display: inline-block;
            line-height: 2;
            margin-bottom: 2rem;
            font-size: 20px;
            .gh-highlight {
                width: fit-content;
                background: #CEEFEB;
                padding: 0.7rem 1rem;
                border-radius: 25px;
                margin-bottom: 1rem;
                margin-right: 0.5rem;
            }

            a {
                color: #343841;
                text-decoration: underline;
            }
        }
    }

    .c-guarantee {
        max-width: 100%;
        flex-basis: 100%;
    }

    .gh-inclusions {
        margin-top: 3.8rem;
        .gh-inclusions-inner {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
        }
        .gh-section__heading {
            font-size: 2.45rem;
        }
        .el-row {
            max-width: 749px;
        }
        .gh-includes {
            margin-top: 2.9rem;
        }
        .container {
            max-width: 46em;
        }

        .gh-heading-div {
            display: flex;
            justify-content: center;
        }

        img {
            width: 30px;
            height: 30px;
        }

        .gh-text {
            font-size: 1.35rem;
            font-weight: 500;
        }

        .gh-item {
            padding-bottom: 0.9rem;
            margin-bottom: 1.2rem;
            border-bottom: 1px solid #A3A3A3;
        }

        .el-col:last-child {
            .gh-item {
                border-bottom: none;
                margin-bottom: 0;
            }
        }
    }

    .gh-rates {
        background: #EDECF6;
        img {
            width: unset;
        }

        .el-row {
            max-width: 1324px;
            align-items: center;
            justify-content: center;
            display: flex;
        }
        .gh-rates-left {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            span {
                font-size: 1.35rem;
                font-weight: 400;
                margin-right: 1rem;
            }

            .gh-button-redesign {
                padding: .5rem 1rem;
                border-radius: 3px;
                font-size: 1.2rem;
                font-weight: 400;
            }
        }

        .gh-rates-right {
            display: flex;
            flex-flow: row;
            align-items: center;
            img {
                width: 249px;
                height: auto;
            }
        }
    }
    @media screen and (min-width: '767px') {
        .v-or__text {
            margin: 4rem 3rem;
            font-size: 3rem;
        }
    }

    @media screen and (min-width: '600px') {
        .gh-memberships {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 3rem auto;
        }

        .gh-membership-card {
            max-width: 400px;
            margin-bottom: 0;
        }

        .v-or {
            display: block;
        }

        .v-or__text {
            margin: 4rem 1.5rem;
            color: #565a60;
            font-size: 2.5rem;
            font-weight: 700;
            line-height: 1;
        }

        .gh-ribbon {
            padding: 1rem;
        }

        .gh-membership-type {
            font-size: 1.6rem;
        }

        .gh-membership-pricing {
            font-size: 1.3rem;
        }

        .gh-membership-card-header {
            font-size: 1.3rem;
        }

        .gh-pricing-digit {
            font-size: 3rem;
        }

        .c-guarantee {
            max-width: 470px;
            flex-basis: 470px;
        }
    }

    @media screen and (min-width: '1230px') {
        .gh-memberships {
            max-width: 820px;
        }
        .gh-membership-card-header,
        .gh-membership-card-info,
        .gh-membership-card-action {
            padding: 1.5rem;
        }

        .gh-ribbon {
            top: 2rem;
            padding: 1rem 2rem;
        }

        .gh-membership-card-info {
            font-size: 1.8rem;
        }

        .gh-membership-type {
            font-size: 2rem;
        }

        .gh-membership-pricing,
        .gh-membership-card-header {
            font-size: 1.5rem;
        }

        .gh-membership-card-action {
            .gh-button--cta {
                width: 80%;
                font-size: 1.2rem;
            }
        }

        .gh-pricing-digit {
            font-size: 4rem;
            font-weight: 600;
        }

        .gh-inclusion {
            font-size: 1.2rem;
        }

        .v-registration {
            display: flex;
        }

        .v-registration-form {
            flex-grow: 1;
            flex-shrink: 0;
            padding-right: 2rem;
        }
    }

    @media screen and (min-width: '1200px') {
        // .v-registration-form {
        //     .gh-section__heading {
        //         text-align: left;
        //     }
        // }
    }

    @media screen and (min-width: '64em') {
        .v-registration-form {
            // margin-left: calc((100% - 64rem) / 2);
        }
    }

    @media screen and (min-width: '1230px') {
        .v-registration-form {
            margin-left: calc((100% - 76rem) / 2);
            padding-right: 4rem;
        }

        .v-registration-form {
            flex-grow: 1;
            flex-shrink: 0;
            padding-right: 2rem;

            .gh-section__heading {
                text-align: left;
            }
        }

        .c-guarantee {
            max-width: 38.5%;
            flex-basis: 38.5%;
        }
    }

    @media screen and (min-width: '90rem') {
        .gh-rates {
            .container {
                width: 87rem !important;
            }
        }

        .v-registration-form {
            margin-left: calc((100% - 91rem) / 2);
            padding-right: 5rem;
        }
    }

    @media screen and (max-width: '1440px') {
        .gh-rates {
            .el-row {
                padding: .5rem 0;
                flex-flow: column;

                .el-col + .el-col {
                    margin-top: 2rem;
                }
            }

            .gh-rates-left {
                flex-flow: column;
                text-align: center;
                a {
                    margin-top: 1.5rem;
                }
            }
            .gh-rates-right {
                justify-content: center;
            }
        }

        .c-guarantee {
            margin-left: 1rem;
            margin-right: 1rem;
        }
    }

    @media screen and (max-width: '1230px') {
        .v-registration {
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
        }
    }

    @media only screen and (max-width: 767px) {
        .gh-inclusions {
            .gh-inclusions-inner {
                margin-left: 1rem;
                margin-right: 1rem;
            }
        }
    }
</style>
